import { Text } from '@mantine/core';

import type { DateDisplayFormat, DateDisplayViewProps } from './DateDisplay.types';

const FORMATTERS: Record<DateDisplayFormat, Intl.DateTimeFormat> = {
  short: new Intl.DateTimeFormat('da-DK', { day: 'numeric', month: 'short', year: 'numeric' }),
  long: new Intl.DateTimeFormat('da-DK', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  }),
  datetime: new Intl.DateTimeFormat('da-DK', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }),
};

export function DateDisplayView({ date, format = 'short', fallback = '–', c }: DateDisplayViewProps) {
  if (date == null) {
    return (
      <Text size="sm" c={c ?? 'dimmed'} span>
        {fallback}
      </Text>
    );
  }

  const parsed = typeof date === 'string' ? new Date(date) : date;

  if (Number.isNaN(parsed.getTime())) {
    return (
      <Text size="sm" c={c ?? 'dimmed'} span>
        {fallback}
      </Text>
    );
  }

  return (
    <Text size="sm" c={c} span>
      {FORMATTERS[format].format(parsed)}
    </Text>
  );
}
